/**
 * Feature Flags
 * v4.13 - WOW-FLAG-LIVE: REACT_APP_WOW_INSIGHTS_ENABLED now baked in workflow - 2026-07-03
 * v3.90 - W3-1-Step3: WOW_INSIGHTS_ENABLED flag - 2026-07-02
 * v3.77 - SHOW-01: Show Your Work panel flags - 2026-03-13
 *
 * All flags are build-time env vars baked into the JS bundle.
 * Safe default is always OFF so missing env vars never expose unfinished UI.
 */

/** Show the "How we found this" expandable panel on AI-generated cards. */
export const SHOW_YOUR_WORK_ENABLED =
    process.env.REACT_APP_SHOW_YOUR_WORK_ENABLED === 'true';

/**
 * Show the full Level-2 breakdown (data sources list + time period) inside
 * the panel. Requires SHOW_YOUR_WORK_ENABLED to also be true.
 */
export const SHOW_YOUR_WORK_LEVEL2_ENABLED =
    SHOW_YOUR_WORK_ENABLED &&
    process.env.REACT_APP_SHOW_YOUR_WORK_LEVEL2_ENABLED === 'true';

/**
 * v3.90 - W3-1-Step3: WOW visual treatment for hierarchyTier=1/2 insights.
 * Build-time var — requires portal rebuild+deploy to enable (same pattern as
 * SHOW_YOUR_WORK_ENABLED). Set REACT_APP_WOW_INSIGHTS_ENABLED=true in SWA
 * build env to expose the amber chip and wowSourceChunks render.
 */
export const WOW_INSIGHTS_ENABLED =
    process.env.REACT_APP_WOW_INSIGHTS_ENABLED === 'true';
